// Auto-generated by cli-contracts. Do not edit.
import { derivePolicy, isOptionActive } from "./policy-runtime.js";
import type { DerivedPolicy, IntrospectionResult } from "./policy-runtime.js";

export type { DerivedPolicy, IntrospectionResult };

export const commandDefinitions = {
  "graph": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache",
        "analysis-output"
      ]
    }
  },
  "impact": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache",
        "analysis-output"
      ]
    },
    "options": [
      {
        "name": "files",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "symbols",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "artifact",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "diff",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "direction",
        "schema": {
          "type": "string",
          "enum": [
            "downstream",
            "upstream"
          ],
          "default": "downstream"
        }
      },
      {
        "name": "max-depth",
        "schema": {
          "type": "integer"
        }
      }
    ]
  },
  "callgraph": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache",
        "analysis-output"
      ]
    },
    "options": [
      {
        "name": "entry",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "depth",
        "schema": {
          "type": "integer",
          "default": 3
        }
      },
      {
        "name": "direction",
        "schema": {
          "type": "string",
          "enum": [
            "forward",
            "reverse"
          ],
          "default": "forward"
        }
      }
    ]
  },
  "context-pack": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache",
        "analysis-output"
      ]
    },
    "options": [
      {
        "name": "files",
        "schema": {
          "type": "array",
          "items": {
            "type": "string"
          }
        }
      },
      {
        "name": "task",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "budget",
        "schema": {
          "type": "integer",
          "default": 50000
        }
      },
      {
        "name": "granularity",
        "schema": {
          "type": "string",
          "enum": [
            "file",
            "symbol"
          ],
          "default": "file"
        }
      }
    ]
  },
  "dependencies": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache"
      ]
    },
    "options": [
      {
        "name": "file",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "direction",
        "schema": {
          "type": "string",
          "enum": [
            "forward",
            "reverse"
          ],
          "default": "forward"
        }
      }
    ]
  },
  "semantic": {
    "effects": {
      "risk_level": "low",
      "reads": [
        "project-source",
        "dsl-navigation"
      ],
      "writes": [
        "analysis-cache",
        "analysis-output"
      ]
    },
    "options": [
      {
        "name": "adapter",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "model",
        "schema": {
          "type": "string"
        }
      },
      {
        "name": "max-candidates",
        "schema": {
          "type": "integer"
        }
      },
      {
        "name": "dry-run",
        "schema": {
          "type": "boolean",
          "default": false
        }
      }
    ]
  },
  "cache": {},
} as const;

export function deriveCommandPolicy(
  command_id: string,
  optionValues: Record<string, unknown>,
): IntrospectionResult {
  const def = commandDefinitions[command_id as keyof typeof commandDefinitions];
  if (!def) throw new Error(`Unknown command: ${command_id}`);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const cmdDef = def as any;
  const options: Record<string, { value: unknown; specified: boolean; definition: any }> = {};
  const active_options: string[] = [];

  for (const optDef of cmdDef.options ?? []) {
    const value = optionValues[optDef.name];
    const specified = optDef.name in optionValues && value !== undefined;
    options[optDef.name] = { value, specified, definition: optDef };
    if (isOptionActive(optDef, value, specified)) {
      active_options.push(optDef.name);
    }
  }

  const policy = derivePolicy({
    command_id,
    command_effects: cmdDef.effects,
    options,
    env: cmdDef.env,
  });

  return { command: command_id, active_options, policy };
}
